import * as MType from '../vuex/mutation-types'
import userService from '../utils/user'

const isShowLog = false
export default {
  /*
     带参跳转。
     注意：路由中name和path须一致.如：（path: '/hello'   name: 'hello'）
     此跳转方法到目标界面，参数会保留，刷新不会清除
     接收参数方法：
     computed: {
       params: function () {
         return {
           languageType: this.$route.query.languageType,
           productId: this.$route.query.productId,
           identify: this.$route.query.identify
         }
       }
     }
     */
  startView (name, params) {
    if (this.isNotEmpty(name)) {
      this.$router.push({
        path: '/' + name,
        name: name,
        query: params
      })
    }
  },
  // 替换view
  replaceView (name, params) {
    if (this.isNotEmpty(name)) {
      this.$router.replace({
        path: '/' + name,
        name: name,
        query: params
      })
    }
  },
  // 返回上一页
  backView () {
    this.$router.go(-1)
  },
  // 统一跳转方法
  base_go (url, isReplace) {
    if (url) {
      if (isReplace) {
        this.$router.replace({path: url})
      } else {
        this.$router.push({path: url})
      }
    }
  },
  // 统一回退方法
  base_goBack (isReplace) {
    let count = window.sessionStorage.getItem('count') || 0
    let url = window.sessionStorage.key(count) || '/' // 当前url
    let url1 = window.sessionStorage.key(count - 1) || '/' // 上次访问的url
    if (this.$route.path === url) { // 和当前URL一致
      if (isReplace) {
        this.$router.replace({path: url1})
      } else {
        this.$router.push({path: url1})
      }
    } else {
      if (isReplace) {
        this.$router.replace({path: url})
      } else {
        this.$router.push({path: url})
      }
    }
  },

  getUrl (url) {
    if (url.includes('http:') || url.includes('https:')) return url
    if (url.includes('/newWeb/')) return url
    if (url.charAt(0) === '/') return '/web' + url
    else return '/web/' + url
  },

  getHttpData (url, params, callback, error, isLoading) {
    // ----------------------------------------------------------------
    params = params || null
    isLoading = true
    this.$store.commit(MType.UPDATE_LOADING, isLoading)
    // -----------------------------------------------------------------
    this.$http.get(this.getUrl(url), {params: params}).then(response => {
      if (isShowLog) {
        console.log('GET请求', response)
      }
      let result = response.data
      // -------------------------------------------------------
      // this.log('GET请求', JSON.stringify(result))
      // -----------------------------------
      this.$store.commit(MType.UPDATE_LOADING, false)
      // ------------------------------------
      if (result === undefined) {
        return callback(false)
      } else if (result.status !== '1' && result.status !== 1) {
        // 设置errorMsg
        this.$store.commit(MType.UPDATE_ERROR_MSG, result.msg)
        return callback(false, this.$store, result.msg)
      } else if (result.result) {
        return callback(result.result, this.$store, result.msg)
      } else {
        return callback(true, this.$store, result.msg)
      }
    }).catch(e => {
      this.$store.commit(MType.UPDATE_LOADING, false)
      if (error) {
        return error(e)
      } else {
        this.$store.commit(MType.UPDATE_ERROR_MSG, e.message)
        return false
      }
    })
  },

  getTwoCycleHttpData (url, params, callback, error, isLoading) {
    // ----------------------------------------------------------------
    params = params || null
    isLoading = true
    this.$store.commit(MType.UPDATE_LOADING, isLoading)
    // -----------------------------------------------------------------
    this.$http.get(this.getUrl(url), {params: params}).then(response => {
      if (isShowLog) {
        console.log('GET请求', response)
      }
      let result = response.data
      // -------------------------------------------------------
      // this.log('GET请求', JSON.stringify(result))
      // -----------------------------------
      this.$store.commit(MType.UPDATE_LOADING, false)
      // ------------------------------------
      if (result === undefined) {
        return callback(false)
      } else if (result.status !== '1' && result.status !== 1) {
        // 设置errorMsg
        this.$store.commit(MType.UPDATE_ERROR_MSG, result)
        return callback(result.result, this.$store, result)
      } else if (result.result) {
        return callback(result.result, this.$store, result)
      } else {
        return callback(true, this.$store, result)
      }
    }).catch(e => {
      this.$store.commit(MType.UPDATE_LOADING, false)
      if (error) {
        return error(e)
      } else {
        this.$store.commit(MType.UPDATE_ERROR_MSG, e.message)
        return false
      }
    })
  },
  getTwoCyclePriceType (index) {
    switch (index) {
      case 0:
        return '大人'
      case 1:
        return '小児'
      case 2:
        return '障害者大人'
      case 3:
        return '障害者小児'
    }
  },
  getTwoCyclePriceTypes () {
    return '大人，小児，障害者大人，障害者小児'
  },
  downloadExcelHttpData (url, params) {
    params = params || null
    let qs = require('qs')
    params = params || {}
    let xhr = new XMLHttpRequest()
    xhr.open('GET', this.getUrl(url) + '?' + qs.stringify(params), true) // get请求，请求地址，是否异步
    xhr.responseType = 'blob'
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.setRequestHeader('uiLang', window.sessionStorage.getItem('langType'))
    xhr.setRequestHeader('accessToken', window.sessionStorage.getItem('accessToken'))
    xhr.onload = function () {
      if (this.status === 200) {
        // 获得文件名
        let filename = this.getResponseHeader('content-disposition').split('filename=')[1]
        let blob = this.response
        let reader = new FileReader()
        reader.readAsDataURL(blob)  // 转换为base64，可以直接放入a标签href
        reader.onload = function (e) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename)
          } else {
            // 转换完成，创建一个a标签用于下载
            let a = document.createElement('a')
            a.download = filename
            a.href = e.target.result
            document.body.appendChild(a)  // 修复firefox中无法触发click
            a.click()
            a.remove()
          }
        }
      }
    }
    // 发送ajax请求
    xhr.send()
  },
  // 下载excel 同步
  // 2019-08-21 解决导出订单loading 无法异步显示,需要在此方法中添加返回值,为true时为异步请求数据返回
  downloadExcelHttpData1 (url, params, callback) {
    params = params || null
    let qs = require('qs')
    params = params || {}
    let xhr = new XMLHttpRequest()
    xhr.open('GET', this.getUrl(url) + '?' + qs.stringify(params), true) // get请求，请求地址，是否异步
    xhr.responseType = 'blob'
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.setRequestHeader('uiLang', window.sessionStorage.getItem('langType'))
    xhr.setRequestHeader('accessToken', window.sessionStorage.getItem('accessToken'))
    xhr.onload = function () {
      if (this.status === 200) {
        // 获得文件名
        let filename = this.getResponseHeader('content-disposition').split('filename=')[1]
        let blob = this.response
        let reader = new FileReader()
        reader.readAsDataURL(blob)  // 转换为base64，可以直接放入a标签href
        reader.onload = function (e) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename)
          } else {
            // 转换完成，创建一个a标签用于下载
            let a = document.createElement('a')
            a.download = filename
            a.href = e.target.result
            document.body.appendChild(a)  // 修复firefox中无法触发click
            a.click()
            a.remove()
          }
        }
      }
      return callback(true)
    }
    // 发送ajax请求
    xhr.send()
    return callback(false)
  },
  // 下载zip 同步
  downloadZipHttpData1 (url, params, callback) {
    params = params || null
    let qs = require('qs')
    params = params || {}
    let xhr = new XMLHttpRequest()
    xhr.open('GET', this.getUrl(url) + '?' + qs.stringify(params), true) // get请求，请求地址，是否异步
    xhr.responseType = 'blob'
    xhr.setRequestHeader('Content-Type', 'application/octet-stream')
    xhr.setRequestHeader('uiLang', window.sessionStorage.getItem('langType'))
    xhr.setRequestHeader('accessToken', window.sessionStorage.getItem('accessToken'))
    xhr.onload = function () {
      if (this.status === 200) {
        // 获得文件名
        let filename = this.getResponseHeader('content-disposition').split('filename=')[1]
        let blob = this.response
        let reader = new FileReader()
        reader.readAsDataURL(blob)  // 转换为base64，可以直接放入a标签href
        reader.onload = function (e) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename)
          } else {
            // 转换完成，创建一个a标签用于下载
            let a = document.createElement('a')
            a.download = filename
            // a.href = e.target.result
            a.href = URL.createObjectURL(blob)
            document.body.appendChild(a)  // 修复firefox中无法触发click
            a.click()
            a.remove()
          }
        }
      }
      return callback(true)
    }
    // 发送ajax请求
    xhr.send()
    return callback(false)
  },
  postHttpData (url, params, callback, error, isLoading) {
    // ----------------------------------------------------------------
    params = params || null
    isLoading = true
    this.$store.commit(MType.UPDATE_LOADING, isLoading)
    // -----------------------------------------------------------------
    this.$http.post(this.getUrl(url), params).then(response => {
      if (isShowLog) {
        console.log('POST请求', response)
      }
      let result = response.data
      // -------------------------------------------------------
      // this.log('POST请求', JSON.stringify(result))
      // this.log('POST请求', result)
      // -------------------------------------------------------
      this.$store.commit(MType.UPDATE_LOADING, false)
      // -------------------------------------------------------
      if (result === undefined) {
        return callback(false)
      } else if (result.status !== '1' && result.status !== 1) {
        // 等于 0 为失败
        // 设置errorMsg
        this.$store.commit(MType.UPDATE_ERROR_MSG, result.message)
        return callback(false, this.$store, result.message)
      } else if (result.result) {
        return callback(result.result, this.$store, result.message)
      } else if (result.data) {
        return callback(result.data, this.$store, result.message)
      } else {
        return callback(true, this.$store, result.message)
      }
    }).catch(e => {
      this.$store.commit(MType.UPDATE_LOADING, false)
      if (error) {
        return error(e)
      } else {
        this.$store.commit(MType.UPDATE_ERROR_MSG, e.message)
        return false
      }
    })
  },

  postOutHttpData (url, params, callback, error, isLoading) {
    // ----------------------------------------------------------------
    params = params || null
    isLoading = true
    this.$store.commit(MType.UPDATE_LOADING, isLoading)
    // -----------------------------------------------------------------
    this.$http.post(url, params).then(response => {
      if (isShowLog) {
        console.log('POST请求', response)
      }
      let result = response.data
      // -------------------------------------------------------
      // this.log('POST请求', JSON.stringify(result))
      // this.log('POST请求', result)
      // -------------------------------------------------------
      this.$store.commit(MType.UPDATE_LOADING, false)
      // -------------------------------------------------------
      if (result === undefined) {
        return callback(false)
      } else if (result.status !== '1' && result.status !== 1) {
        // 等于 0 为失败
        // 设置errorMsg
        this.$store.commit(MType.UPDATE_ERROR_MSG, result.message)
        return callback(false, this.$store, result.message)
      } else if (result.result) {
        return callback(result.result, this.$store, result.message)
      } else {
        return callback(true, this.$store, result.message)
      }
    }).catch(e => {
      this.$store.commit(MType.UPDATE_LOADING, false)
      if (error) {
        return error(e)
      } else {
        this.$store.commit(MType.UPDATE_ERROR_MSG, e.message)
        return false
      }
    })
  },
  postZIPHttpData (url, params, callback, error, isLoading) {
    // ----------------------------------------------------------------
    params = params || null
    isLoading = true
    this.$store.commit(MType.UPDATE_LOADING, isLoading)
    console.log(params)
    // -----------------------------------------------------------------
    this.$http.post(this.getUrl(url), params).then(response => {
      if (isShowLog) {
        console.log('POST请求', response)
      }
      let result = response.data
      // -------------------------------------------------------
      // this.log('POST请求', JSON.stringify(result))
      // this.log('POST请求', result)
      // -------------------------------------------------------
      this.$store.commit(MType.UPDATE_LOADING, false)
      // -------------------------------------------------------
      if (result === undefined) {
        return callback(false)
      } else if (result.status !== '1' && result.status !== 1) {
      // 等于 0 为失败
      // 设置errorMsg
        this.$store.commit(MType.UPDATE_ERROR_MSG, result.message)
        return callback(false, this.$store, result.message)
      } else if (result.result) {
        return callback(result.result, this.$store, result.message)
      } else {
        return callback(true, this.$store, result.message)
      }
    }).catch(e => {
      this.$store.commit(MType.UPDATE_LOADING, false)
      if (error) {
        return error(e)
      } else {
        this.$store.commit(MType.UPDATE_ERROR_MSG, e.message)
        return false
      }
    })
  },
  uploadHttpData (url, params, callback, error, isLoading) {
    isLoading = true
    params = params || new FormData()
    this.$store.commit(MType.UPDATE_LOADING, isLoading)
    this.$http.post(this.getUrl(url), params, {
      method: 'post',
      headers: {'Content-Type': 'multipart/form-data'}
    }).then(response => {
      if (isShowLog) {
        console.log('上传', response)
      }
      this.$store.commit(MType.UPDATE_LOADING, false)
      let result = response.data
      if (result.status !== '1' && result.status !== 1) {
        this.$store.commit(MType.UPDATE_ERROR_MSG, result.msg)
        callback && callback(false, this.$store, result.msg)
      } else if (result === undefined) {
        callback && callback(false, this.$store, result.msg)
      } else if (result.result) {
        callback && callback(result, this.$store, result.msg)
      } else {
        callback && callback(true, this.$store, result.msg)
      }
    }).catch(e => {
      this.$store.commit(MType.UPDATE_LOADING, false)
      if (error) {
        error(e)
      } else {
        this.$store.commit(MType.UPDATE_ERROR_MSG, e.message)
      }
    })
  },
  postHttp (url, params, callback) {
    // ----------------------------------------------------------------
    params = params || null
    this.$store.commit(MType.UPDATE_LOADING, true)
    // -----------------------------------------------------------------
    this.$http.post(this.getUrl(url), params).then(response => {
      this.$store.commit(MType.UPDATE_LOADING, false)
      let data = response.data
      /*
        result.status
         1: 成功
         0: 失败
        result.code
        -1: 获取到的数据中没有这个值
     */
      if (data) {
        if (data.status) data.status = parseInt(data.status)
        else data.status = -1
        if (data.code) data.code = parseInt(data.code)
        else data.code = -1
      } else {
        data = { status: 0, code: -1 }
      }
      this.handleResult(data, callback)
    }).catch(error => {
      console.log('tag new->', error)
      this.$store.commit(MType.UPDATE_LOADING, false)
    })
  },
  handleResult (data, callback) {
    // console.log('tag ---err', JSON.stringify(data))
    if (data.status === 1) {
      callback(true)
    } else {
      switch (data.code) {
        case -1:
          callback(false)
          break
        case 100:
          callback(false, this.$t('errMsg.errMsg100'), data)
          break
        case 101:
          callback(false, this.$t('errMsg.errMsg101'), data)
          break
        case 102:
          callback(false, this.$t('errMsg.errMsg102'), data)
          break
        case 103:
          callback(false, this.$t('errMsg.errMsg103'), data)
          break
        case 104:
          callback(false, this.$t('errMsg.errMsg104'), data)
          break
        case 105:
          callback(false, this.$t('errMsg.errMsg105'), data)
          break
        case 106:
          callback(false, this.$t('errMsg.errMsg106'), data)
          break
        case 107:
          callback(false, this.$t('errMsg.errMsg107'), data)
          break
        case 108:
          callback(false, this.$t('errMsg.errMsg108'), data)
          break
        case 109:
          callback(false, this.$t('errMsg.errMsg109'), data)
          break
        case 110:
          callback(false, this.$t('errMsg.errMsg110'), data)
          break
        case 111:
          callback(false, this.$t('errMsg.errMsg111'), data)
          break
        case 112:
          callback(false, this.$t('errMsg.errMsg112'), data)
          break
        case 113:
          callback(false, this.$t('errMsg.errMsg113'), data)
          break
        case 114:
          callback(false, this.$t('errMsg.errMsg114'), data)
          break
        case 115:
          callback(false, this.$t('errMsg.errMsg115'), data)
          break
        case 116:
          callback(false, this.$t('errMsg.errMsg116'), data)
          break
        case 117:
          callback(false, this.$t('errMsg.errMsg117'), data)
          break
        case 118:
          callback(false, this.$t('errMsg.errMsg118'), data)
          break
        case 119:
          callback(false, this.$t('errMsg.errMsg119'), data)
          break
        case 120:
          callback(false, this.$t('errMsg.errMsg120'), data)
          break
      }
    }
  },
  newGuid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  },
  openWindow_newHome (path, params = {}) {
    const routeData = this.$router.resolve({
      path: `/${path}`,
      query: {
        accessToken: userService.getAccessToken(),
        uiLang: userService.getUiLang(),
        newHome: true,
        ...params
      }
    })
    window.open(routeData.href, '_blank')
  },
  getSalesText (sales) {
    sales = Number(sales)
    // this.$t('newHome.salesLessThan1k')
    return sales < 1000 ? '1k' : ((sales / 1000).toFixed(1) + 'k+')
  },
  toThousands (num) {
    let result = ''
    let counter = 0
    num = (num || 0).toString().split('')
    for (let i = num.length - 1; i >= 0; i--) {
      counter++
      result = num[i] + result
      if (!(counter % 3) && i !== 0) { result = ',' + result }
    }
    return result === '0' ? '' : result
  },
  getCategoryKey (category) {
    switch (category) {
      case 'transport': return 1
      case 'themePark': return 2
      case 'wifi': return 3
      case 'carRental': return 4
      case 'dayTrip': return 5
      case 'hotel': return 6
      default: return ''
    }
  },
  getProductTypeById (id) {
    switch (Number(id)) {
      case 0: return 'lable.ticketType0'
      case 1: return 'lable.ticketType1'
      case 2: return 'lable.ticketType22'
      case 3: return 'lable.ticketType33'
      case 4: return 'lable.ticketType4'
      case 5: return 'lable.ticketType5'
      case 6: return 'lable.ticketType66'
      case 7: return 'lable.ticketType77'
      case 8: return 'lable.ticketType88'
      case 9: return 'lable.ticketType99'
      default: return null
    }
  },
  getLanguageType (type) {
    switch (type) {
      case '1':
      case 1:
        return 'zh'
      case '2':
      case 2:
        return 'tw'
      case '3':
      case 3:
        return 'en'
      case '4':
      case 4:
        return 'ko'
      case '5':
      case 5:
        return 'ja'
      default: return type
    }
  },
  translateFormData (callback) {
    if (this.lastLanguageData.data && this.lastLanguageData.source && this.lastLanguageData.target && this.lastLanguageData.source !== this.lastLanguageData.target) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('lable.translationing'),
        spinner: 'el-icon-loading',
        background: 'rgba(5, 4, 4, 0.7)'
      })
      const source = this.getLanguageType(this.lastLanguageData.source)
      const target = this.getLanguageType(this.lastLanguageData.target)

      let params = {
        ...this.lastLanguageData.data,
        source: source === 'tw' ? 'zh-Hant' : source,
        target: target === 'tw' ? 'zh-Hant' : target
      }
      this.postHttpData(process.env.VUE_APP_TRANSLATE_API + '/EasyGoTranslate/Translate', params, (data) => {
        loading.close()
        if (data && callback) {
          delete data.id
          delete data.createTime
          callback(true, data)
        }
      }, () => { loading.close() })
    } else this.$message.warning(this.$t('lable.translationTip'))
  },
  getTranslationForLocale (key, localeType) {
    // 获取目标语言
    const locale = this.getLanguageType(localeType)
    // 当前语言
    const currentLocale = this.$i18n.locale

    if (!key) return 'error-key'
    if (!locale || locale === currentLocale) return this.$i18n.t(key)

    return this.$i18n.t(key, locale)
  },

  // 获取字符串是否包含大小写字母
  hasCaseLetter (str) {
    return /[a-zA-Z]/.test(str)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js